var _circle, _g, _g2, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBuy5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#13AE67",
    fillOpacity: 0.08
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_4551_75671)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_4551_75671",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.875 33.498C22.875 31.2889 24.6659 29.498 26.875 29.498H56C58.2091 29.498 60 31.2889 60 33.498V36.2482C57.204 36.2482 54.9375 38.5147 54.9375 41.3107C54.9375 44.1066 57.204 46.3732 60 46.3732V49.123C60 51.3322 58.2091 53.123 56 53.123H26.875C24.6659 53.123 22.875 51.3322 22.875 49.123V46.3732C25.6709 46.3732 27.9375 44.1066 27.9375 41.3107C27.9375 38.5147 25.6709 36.2482 22.875 36.2482V33.498Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.875 33.498C22.875 31.2889 24.6659 29.498 26.875 29.498H56C58.2091 29.498 60 31.2889 60 33.498V36.2482C57.204 36.2482 54.9375 38.5147 54.9375 41.3107C54.9375 44.1066 57.204 46.3732 60 46.3732V49.123C60 51.3322 58.2091 53.123 56 53.123H26.875C24.6659 53.123 22.875 51.3322 22.875 49.123V46.3732C25.6709 46.3732 27.9375 44.1066 27.9375 41.3107C27.9375 38.5147 25.6709 36.2482 22.875 36.2482V33.498Z",
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 36.2482V38.0223H61.7741V36.2482H60ZM60 46.3732H61.7741V44.599H60V46.3732ZM22.875 46.3732V44.599H21.1008V46.3732H22.875ZM22.875 36.2482H21.1008V38.0223H22.875V36.2482ZM26.875 27.7239C23.686 27.7239 21.1008 30.3091 21.1008 33.498H24.6492C24.6492 32.2688 25.6457 31.2722 26.875 31.2722V27.7239ZM56 27.7239H26.875V31.2722H56V27.7239ZM61.7741 33.498C61.7741 30.3091 59.189 27.7239 56 27.7239V31.2722C57.2293 31.2722 58.2258 32.2688 58.2258 33.498H61.7741ZM61.7741 36.2482V33.498H58.2258V36.2482H61.7741ZM56.7117 41.3107C56.7117 39.4946 58.1839 38.0223 60 38.0223V34.474C56.2242 34.474 53.1633 37.5349 53.1633 41.3107H56.7117ZM60 44.599C58.1839 44.599 56.7117 43.1268 56.7117 41.3107H53.1633C53.1633 45.0865 56.2242 48.1473 60 48.1473V44.599ZM61.7741 49.123V46.3732H58.2258V49.123H61.7741ZM56 54.8972C59.189 54.8972 61.7741 52.312 61.7741 49.123H58.2258C58.2258 50.3523 57.2293 51.3489 56 51.3489V54.8972ZM26.875 54.8972H56V51.3489H26.875V54.8972ZM21.1008 49.123C21.1008 52.312 23.686 54.8972 26.875 54.8972V51.3489C25.6457 51.3489 24.6492 50.3523 24.6492 49.123H21.1008ZM21.1008 46.3732V49.123H24.6492V46.3732H21.1008ZM26.1633 41.3107C26.1633 43.1268 24.6911 44.599 22.875 44.599V48.1473C26.6508 48.1473 29.7117 45.0865 29.7117 41.3107H26.1633ZM22.875 38.0223C24.6911 38.0223 26.1633 39.4946 26.1633 41.3107H29.7117C29.7117 37.5349 26.6508 34.474 22.875 34.474V38.0223ZM21.1008 33.498V36.2482H24.6492V33.498H21.1008Z",
    fill: "url(#paint0_linear_4551_75671)",
    mask: "url(#path-2-inside-1_4551_75671)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_4551_75671)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18.877,
    width: 37.125,
    height: 23.625,
    rx: 4,
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.8871,
    y: 19.764,
    width: 35.3508,
    height: 21.8508,
    rx: 3.11292,
    stroke: "url(#paint1_linear_4551_75671)",
    strokeWidth: 1.77417
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.5024,
    y: 24.7832,
    width: 34.1166,
    height: 5.0625,
    fill: "url(#paint2_linear_4551_75671)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_4551_75671",
    x: 19.3267,
    y: 25.9497,
    width: 44.2217,
    height: 30.7217,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.77417
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4551_75671"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4551_75671",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_4551_75671",
    x: 8.45166,
    y: 15.3286,
    width: 44.2217,
    height: 30.7217,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.77417
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4551_75671"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4551_75671",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4551_75671",
    x1: 25.3591,
    y1: 29.498,
    x2: 60.3839,
    y2: 52.5394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4551_75671",
    x1: 14.4841,
    y1: 18.877,
    x2: 49.5089,
    y2: 41.9183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4551_75671",
    x1: 13.5024,
    y1: 26.7985,
    x2: 48.1131,
    y2: 26.7053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBuy5);
export default __webpack_public_path__ + "static/media/ic-buy5.13e8f36bbb2b92b40aca345269450a67.svg";
export { ForwardRef as ReactComponent };